export { SORT_TYPES } from './sortTypes';

export const CURRENT_MEMBERS_COLUMNS = [
  { id: 'member_name', label: 'Member', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'email', label: 'Email', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'product_name', label: 'Membership', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'status', label: 'Status', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'amount', label: 'Amount', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'interval', label: 'Billing', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'member_since', label: 'Member Since', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'renews_at', label: 'Renews', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'venue_name', label: 'Venue', defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'sold_by', label: 'Sold By', defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'device_name', label: 'Device', defaultVisible: false, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  CURRENT_MEMBERS_COLUMNS.filter((c) => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  CURRENT_MEMBERS_COLUMNS.filter((c) => !c.defaultVisible && !c.alwaysVisible);
